import React, { useContext } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import WarningIcon from "@material-ui/icons/Warning";
import PersonIcon from "@material-ui/icons/Person";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import InfoIcon from "@material-ui/icons/Info";
import { Grid, Typography } from "@material-ui/core";
import { useTranslation } from "../../../hooks/useTranslation";
import UserContext from "../../../context/user-context";
const useStyles = makeStyles(() =>
  createStyles({
    error: {
      color: "#FF3E1D",
    },
    success: {
      color: "green",
    },
  })
);

const TypeEntrant = () => {
  const classes = useStyles();
  const { state } = useContext(UserContext);
  const { t, BundleKey } = useTranslation();
  return (
    <Grid container direction="row">
      {state.isResident && (
        <Grid item xs={12} className={classes.success}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={1}>
              <PersonIcon fontSize="small" />
            </Grid>
            <Grid item xs={11}>
              <Typography variant="caption" display="block" gutterBottom>
                {t(BundleKey.DETAIL_PERSONALINF_RESIDENT)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        className={
          state.registrationType === "basic" ? classes.error : classes.success
        }
      >
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={1}>
            {state.registrationType === "basic" ? (
              <WarningIcon fontSize="small" />
            ) : (
              <InfoIcon fontSize="small" />
            )}
          </Grid>
          <Grid item xs={11}>
            <Typography variant="caption" display="block" gutterBottom>
              {state.registrationType === "basic" &&
                t(BundleKey.DETAIL_PERSONALINF_TYPEBASIC)}
              {state.registrationType === "full" &&
                t(BundleKey.DETAIL_PERSONALINF_TYPEFULL)}
              {state.registrationType === "mrz" &&
                t(BundleKey.DETAIL_PERSONALINF_TYPEMRZ)}
              {state.registrationType === "express" &&
                t(BundleKey.DETAIL_PERSONALINF_TYPEEXPRESS)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {state.accessPrevalidationStatus && state.config?.eventType === "in" ? (
        <Grid
          item
          className={
            state.accessPrevalidationStatus === "success"
              ? classes.success
              : classes.error
          }
        >
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={1}>
              {state.accessPrevalidationStatus === "success" ? (
                <CheckCircleIcon fontSize="small" />
              ) : (
                <CancelIcon fontSize="small" />
              )}
            </Grid>
            <Grid item xs={11}>
              <Typography variant="caption" display="block" gutterBottom>
                {state.accessPrevalidationStatus === "success"
                  ? t(BundleKey.DETAIL_PERSONALINF_PREVALIDATE_SUCCESS)
                  : t(BundleKey.DETAIL_PERSONALINF_PREVALIDATE_DENIED)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
};
export default TypeEntrant;
